module.exports = __webpack_public_path__ + "img/header-weddingRingsMorningGlow@2x.eb66c71.jpg";